var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4545 0H2.31818C2.24318 0 2.18182 0.0602679 2.18182 0.133929V1.07143C2.18182 1.14509 2.24318 1.20536 2.31818 1.20536H10.7727V12.7232C10.7727 12.7969 10.8341 12.8571 10.9091 12.8571H11.8636C11.9386 12.8571 12 12.7969 12 12.7232V0.535714C12 0.239397 11.7563 0 11.4545 0ZM9.27273 2.14286H0.545455C0.24375 2.14286 0 2.38225 0 2.67857V11.5631C0 11.7054 0.0579544 11.841 0.160227 11.9414L3.1142 14.8426C3.1517 14.8795 3.19432 14.9096 3.24034 14.9347V14.9665H3.31193C3.37159 14.9883 3.43466 15 3.49943 15H9.27273C9.57443 15 9.81818 14.7606 9.81818 14.4643V2.67857C9.81818 2.38225 9.57443 2.14286 9.27273 2.14286ZM3.23864 13.2623L1.77102 11.8192H3.23864V13.2623ZM8.59091 13.7946H4.32955V11.4174C4.32955 11.0474 4.02443 10.7478 3.64773 10.7478H1.22727V3.34821H8.59091V13.7946Z",
    fill: "#D4D7DD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.498a317767955309450ff517b73b901d.svg";
export { ForwardRef as ReactComponent };